import "@shoelace-style/shoelace/dist/components/button/button.js";
import "@shoelace-style/shoelace/dist/components/input/input.js";

import { css, html, LitElement } from "lit";
import { customElement, query, state } from "lit/decorators.js";
import { Style } from "../Styles";
import { validatePassword } from "./Utils";
import { updatePassword } from "aws-amplify/auth";

@customElement("ds-auth-change-password")
export class AuthChangePassword extends LitElement {
    static override styles = [Style, css``];

    @state() protected _valid = false;
    @state() protected _errorMsg = "";

    @query("#old-password") protected _oldPassword: HTMLInputElement | undefined;
    @query("#password1") protected _password1: HTMLInputElement | undefined;
    @query("#password12") protected _password2: HTMLInputElement | undefined;

    protected override firstUpdated(): void {
        this._validateForm();
    }

    private _validate() {
        const oldPassword = this._oldPassword?.value;
        const password1 = this._password1?.value;
        const password2 = this._password2?.value;

        if (oldPassword && !validatePassword(oldPassword)) {
            this._errorMsg = "Old password is invalid";
        } else if (password1 && !validatePassword(password1)) {
            this._errorMsg = "Invalid password";
        } else if (password2 && password1 != password2) {
            this._errorMsg = "Passwords do not match";
        } else {
            this._errorMsg = "";
            return true;
        }

        return false;
    }

    private async _changePassword() {
        if (this._oldPassword && this._password1 && this._validate()) {
            try {
                const oldPassword = this._oldPassword.value;
                const newPassword = this._password1.value;
                await updatePassword({ oldPassword, newPassword });
                this.dispatchEvent(
                    new CustomEvent("on-success", {
                        bubbles: true,
                        composed: true,
                    })
                );
                this.reset();
            } catch (ex: any) {
                this._errorMsg = ex.toString();
            }
        }
    }

    private _validateForm() {
        this._valid = this._validate();
    }

    reset() {
        this._valid = false;
        if (this._oldPassword) this._oldPassword.value = "";
        if (this._password1) this._password1.value = "";
        if (this._password2) this._password2.value = "";
    }

    override render() {
        return html`<div>
            <form @submit=${this._changePassword}>
                <sl-input
                    class="custom-input"
                    id="old-password"
                    label="Old password"
                    clearable
                    required
                    passwordToggle
                    size="medium"
                    type="password"
                    placeholder="********"
                    @sl-input="${this._validateForm}"
                    required
                    filled
                >
                </sl-input>
                <br />
                <sl-input
                    class="custom-input"
                    id="password1"
                    label="Password"
                    passwordToggle
                    required
                    size="medium"
                    type="password"
                    placeholder="********"
                    @sl-input="${this._validateForm}"
                    filled
                >
                </sl-input>
                <br />
                <sl-input
                    class="custom-input"
                    id="password12"
                    label="Repeat password"
                    passwordToggle
                    required
                    size="medium"
                    type="password"
                    placeholder="********"
                    @sl-input="${this._validateForm}"
                    filled
                >
                </sl-input>
                <div>
                    <h4
                        class="surface-error-color"
                        ?hidden="${!this._errorMsg || this._errorMsg.length === 0}"
                    >
                        ${this._errorMsg}
                    </h4>
                </div>
                <br />
                <div class="button-row">
                    <sl-button
                        style="margin-left:auto"
                        variant="default"
                        @click=${() => {
                            this.reset();
                            this.dispatchEvent(
                                new CustomEvent("on-cancel", {
                                    bubbles: true,
                                    composed: true,
                                })
                            );
                        }}
                        >Cancel</sl-button
                    >

                    <sl-button variant="success" type="submit" ?disabled="${!this._valid}"
                        >Change</sl-button
                    >
                </div>
            </form>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-auth-change-password": AuthChangePassword;
    }
}
